import translationKeys from './lib/translationKeys';
import en from './lib/translations/en';
import no from './lib/translations/no';

const translations: Record<string, Record<string, string>> = {
  'en-GB': en,
  'nb-NO': no,
};

export { translations, translationKeys };
